import Authorization from './Authorization'

export default function UserHasPermissions (router) {
	router.beforeEach((to, from, next) => {
		if (to.matched.some(record => record.meta.requiredAuth) && !Authorization.authorize(to.meta.requiredRoles)) {
			next({ name: 'AuthLogin', query: { redirect: to.fullPath } })
		} else {
			next()
		}
	})
}



// WEBPACK FOOTER //
// ./src/authorization/UserHasPermissions.js